import React, { useState } from 'react';
import { DatePicker, Form, Input, message } from 'antd';
import { manualDiscountInsurAmountFromAccount } from '@/services/insureManagement'
import { SFuncModal } from 'shj-components';
import dayjs from 'dayjs'
export function RenewalModel({ fn, ...rest }: any) {
    const onClose = () => {
        dialog.destroy();
    };

    const dialog = SFuncModal({
        title: '手动投保',
        width: 500,
        vanish: true,
        content: <Renewal onClose={onClose} fn={fn} {...rest} />,
    });

    return dialog;
}

const Renewal = ({ onClose, fn, ...rest }: any) => {
    const [form] = Form.useForm();
    let endTime = dayjs(rest.endTime)
    form.setFieldsValue({ ...rest,endTime });
    const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
    const handleSubmit = () => {
            setAddOrEditFooterLoading(true);
            manualDiscountInsurAmountFromAccount(rest.id).then((response: any) => {
                message.success(response.message || '操作成功')
                fn && fn();
                onClose();
            })
                .finally(() => {
                    setAddOrEditFooterLoading(false);
                });
    };
    return (
        <SFuncModal.Content
            onCancel={onClose}
            onOk={handleSubmit}
            confirmLoading={addOrEditFooterLoading}>
            <Form form={form} layout="vertical">
                <Form.Item label="姓名：" name="employeeName">
                    <Input disabled />
                </Form.Item>
                <Form.Item label="到期日期：" name="endTime">
                <DatePicker
                  disabled={true}
                />
              </Form.Item>
            </Form>
        </SFuncModal.Content>
    );
};
